import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { OfferSection } from '../components/OfferSection';
import { FAQ } from '../components/FAQ';
import { StickyCTA } from '../components/StickyCTA';
import { Footer } from '../components/Footer';
import { ExitIntentPopup } from '../components/ExitIntentPopup';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-blue-100 selection:text-blue-900" data-id="element-255">
      <header className="absolute top-0 left-0 right-0 z-50 py-6" data-id="element-256">
        <div className="container mx-auto px-4" data-id="element-257">
          <div className="font-bold text-white text-xl tracking-tight" data-id="element-258">
            Cero Pánico<span className="text-blue-400" data-id="element-259">.</span>
          </div>
        </div>
      </header>

      <main data-id="element-260">
        <Hero data-id="element-261" />
        <ProblemSection data-id="element-262" />
        <SolutionSection data-id="element-263" />
        <OfferSection data-id="element-264" />
        <FAQ data-id="element-265" />
      </main>

      <Footer data-id="element-266" />
      <StickyCTA data-id="element-267" />
      <ExitIntentPopup data-id="element-268" />
    </div>;
}